import React from "react";
import PropTypes from "prop-types";
import "./styles.scss";

const NoAddressesError = ({
  message,
  secondaryMessage
}) => /*#__PURE__*/React.createElement("div", {
  className: "postcode-finder-error"
}, /*#__PURE__*/React.createElement("div", {
  className: "error-text"
}, message), !!secondaryMessage && /*#__PURE__*/React.createElement("div", {
  className: "error-text"
}, secondaryMessage));

NoAddressesError.defaultProps = {
  message: "Unfortunately, we aren’t able to locate that address",
  secondaryMessage: "Please try again"
};
NoAddressesError.propTypes = {
  message: PropTypes.string,
  secondaryMessage: PropTypes.string
};
export default NoAddressesError;